import RestResource from '../rest.service';

export default class FieldsService extends RestResource {
  map(entity) {
    return {
      name: entity.name,
      address: entity.address,
      hectares: entity.hectares || 0,
      latitude: entity.latitude || 0,
      longitude: entity.longitude || 0,
      city_id: typeof entity.city === 'object' ? entity.city.id : entity.city,
      activity: entity.activity || 'Agrícola',
      producer_id: typeof entity.producer === 'object' ? entity.producer.id : entity.producer,
    };
  }

  constructor(params) {
    super('fields', params);
  }
}
